import React from 'react'
import { Col, Row } from 'reactstrap'
import { useLanguage } from '../../contexts/LanguageContext'

const WhyUs = () => {
  const { t } = useLanguage();
  return (
    <div id='website-responsive'>
        <div className='left-padding8rem1 py-lg-5 py-md-2 py-4'>
            <Row className='py-md-3'>
                <Col xs='11' lg='5' className=''>
                    <div className=''>
                        <h3 className='fs-ss-40 text-philos fw-700'>
                            {t('home.whyUs.title')}
                        </h3>
                    </div>
                    <div className='py-md-3'>
                        <h3 className='fs-ss-24 text-mulish fw-500'>
                            {t('home.whyUs.subtitle')}
                        </h3>
                    </div>
                    <div className='pt-2 me-md-4'>
                        <p className='fs-ss-18 text-mulish fw-500 lh-1-2'>
                        {t('home.whyUs.description1')}
                        </p>
                    </div>
                    <div className='pt-2 me-md-4'>
                        <p className='fs-ss-18 text-mulish fw-500 lh-1-2'>
                        <strong>{t('home.whyUs.wavemakers')}</strong> {t('home.whyUs.wavemakersDesc')}
                        </p>
                    </div>
                    <div className='pt-2 me-md-4'>
                        <p className='fs-ss-18 text-mulish fw-500 lh-1-2'>
                        <strong>{t('home.whyUs.innovators')}</strong> {t('home.whyUs.innovatorsDesc')}
                      </p>
                    </div>
                    <div className='pt-2 me-md-4'>
                        <p className='fs-ss-18 text-mulish fw-500 lh-1-2'>
                        <strong>{t('home.whyUs.groundbreakers')}</strong> {t('home.whyUs.groundbreakersDesc')}
                        </p>
                    </div>
                </Col>
                <Col xs='11' lg='5' className=''>
                    <div className='me-md-3'>
                        <img src='home/Why-Us-image.webp' alt='Why IT Junction' className='img-h-3' />
                    </div>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default WhyUs